import React from "react";

import Pluralize from "pluralize";

import dataSourcesApi from "apis/dataSource";
import { Alert, Typography } from "clearsense-ui/components";

const DeleteDataSource = ({
  isDeleteAlertOpen,
  setIsDeleteAlertOpen,
  checkedRows,
  setCheckedRows,
  setIsLoading,
  fetchSteward,
  fetchDataSources,
}) => {
  const deleteRecords = async () => {
    try {
      setIsLoading(true);
      const checkedRowIds = checkedRows.map(row => row.id);
      await dataSourcesApi.delete(checkedRowIds);
      setCheckedRows([]);
      fetchSteward();
      fetchDataSources();
    } catch (error) {
      logger.log(error);
    } finally {
      setIsDeleteAlertOpen(false);
      setIsLoading(false);
    }
  };
  return (
    <Alert
      isOpen={isDeleteAlertOpen}
      title="Delete Data Sources"
      message={
        <Typography>
          {`You are about to delete the following ${Pluralize(
            "Data Source",
            checkedRows.length > 1 ? checkedRows.length : 1,
            true
          )}:`}
          <ul className="px-6 pt-2 overflow-y-auto list-disc h-1/2">
            {checkedRows.map((row, id) => (
              <li key={id}>{row?.name}</li>
            ))}
          </ul>
        </Typography>
      }
      onSubmit={deleteRecords}
      onClose={() => setIsDeleteAlertOpen(false)}
    />
  );
};

export default DeleteDataSource;
